import classNames from "classnames";
import { Col, Form, Row } from "react-bootstrap";
import { RadioArray } from "../../../controls/radioArray";
import PaymentMethodIcon from "../../eshop/order/components/paymentMethodIcon/paymentMethodIcon";
import visa from "../../eshop/order/components/paymentMethodIcon/assets/ic-visa.png";
import masterCard from "../../eshop/order/components/paymentMethodIcon/assets/ic-master-card.png";
import applePay from "../../eshop/order/components/paymentMethodIcon/assets/ic-apple-pay.png";
import * as React from "react";
import { observer } from "mobx-react-lite";
import { DataTestIds } from "../../../data-test-constants";
import { ViewComponent } from "@frui.ts/views";
import SelectPaymentMethodViewModel from "../../../viewModels/common/payment/selectPaymentMethodViewModel";
import { getValidationMessage } from "../../../utils/validationPatch";
import { EshopFormIds } from "../../eshop/test-ids-constants";
import { PaymentType } from "../../../models/payment";
import { icGooglePay } from "../../eshop/order/components/paymentMethodIcon/assets/ic-google-pay";
import { registerView } from "@frui.ts/views/dist";

const SelectPaymentMethod: ViewComponent<SelectPaymentMethodViewModel> = observer(({ vm }) => {
  const validationError = getValidationMessage(vm.chargeOrder, "paymentType");

  return (
    <>
      <Col className={classNames("mb-3", { "is-invalid": validationError })}>
        <Form.Group as={Row} xs="auto" className="mb-0">
          <RadioArray
            custom
            target={vm.chargeOrder}
            property="paymentType"
            name="paymentType"
            disabled={vm.payGateDisabled}
            label={
              <Row>
                <Col xs="auto" className="mb-3">
                  <>{vm.translateAttribute("card")}</>
                </Col>
                <Col xs="auto" className="mb-3">
                  <Row>
                    <PaymentMethodIcon source={visa} height={30} mx="mx-2" />
                    <PaymentMethodIcon source={masterCard} height={30} mx="mx-2" />
                    <PaymentMethodIcon source={applePay} height={30} mx="mx-2" />
                  </Row>
                </Col>
              </Row>
            }
            isNumeric={false}
            id={EshopFormIds.CARD_PAYMENT_RADIO_ARRAY_OPTION}
            option={PaymentType.PayGate}
            data-testid={DataTestIds.CARD_PAYMENT_TYPE_OPTION}
            className="mr-2"
          />
        </Form.Group>
        {vm.enableGooglePay && (
          <Form.Group as={Row} xs="auto" className="mb-0">
            <RadioArray
              custom
              target={vm.chargeOrder}
              property="paymentType"
              name="paymentType"
              isNumeric={false}
              disabled={vm.payGateDisabled}
              label={
                <Row>
                  <Col xs="auto" className="mb-3 mr-0">
                    <>{vm.translateAttribute("googlePay")}</>
                  </Col>
                  <Col xs="auto" className="mb-3 ml-0 pl-1">
                    <img src={icGooglePay} alt="Google Pay" />
                  </Col>
                </Row>
              }
              id={EshopFormIds.GOOGLE_PAY_PAYMENT_RADIO_ARRAY_OPTION}
              option={PaymentType.GooglePay}
              data-testid={DataTestIds.GOOGLE_PAY_PAYMENT_TYPE_OPTION}
              className="mr-2"
            />
          </Form.Group>
        )}
        <Form.Group as={Row} xs="auto" className="mb-3">
          <RadioArray
            custom
            disabled={vm.transferDisabled}
            target={vm.chargeOrder}
            property="paymentType"
            name="paymentType"
            label={vm.paymentTypeLabel}
            isNumeric={false}
            id={EshopFormIds.BANK_TRANSFER_PAYMENT_RADIO_ARRAY_OPTION}
            option={PaymentType.Transfer}
            data-testid={DataTestIds.BANK_TRANSFER_PAYMENT_TYPE_OPTION}
          />
        </Form.Group>
      </Col>
      {validationError && (
        <Form.Control.Feedback type="invalid" className="mb-3">
          {validationError}
        </Form.Control.Feedback>
      )}
    </>
  );
});

registerView(SelectPaymentMethod, SelectPaymentMethodViewModel);
